export default __webpack_public_path__ + "static/media/117951.5d4a8c6a.jpg";